<template lang="pug">
v-dialog(
  max-width="500px",
  v-model="mode.groupDialog",
  persistent,
  scrollable,
  transition="dialog-left-transition"
)
  v-card
    v-card-title.headline.grey.lighten-2.pa-1(primary-title) {{  formTitle(&apos;Group&apos;)  }}
    v-card-text.pa-1
      v-form#group
        v-form-base#groupForm(
          :value="editedItem",
          :schema="schema",
          @input:groupForm="onFormInput"
        )
          my-features(slot="slot-item-key-features")
    v-divider
    v-card-actions
      v-btn(
        color="primary",
        v-if="editedItem.id && editedItem.status === STATUSES.ACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="deActivate(dialogKey)"
      ) De-Activate
      v-btn(
        color="primary",
        v-if="editedItem.id && editedItem.status === STATUSES.INACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="editedItem.status = STATUSES.ACTIVE; save(dialogKey)"
      ) Activate
      v-spacer
      v-btn(color="primary", text, v-on:click.stop="cancel(dialogKey)") Cancel
      v-btn(
        color="primary",
        :disabled="!isDirty",
        text,
        v-on:click.stop="save(dialogKey)"
      ) Save
</template>

<script>
import { globalMixin } from "../../mixins/globalMixin.js";
import { storeMixin } from "../../mixins/storeMixin.js";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";

export default {
  name: "group-dialog",
  mixins: [globalMixin, storeMixin, dialogsMixin],
  data() {
    return {
      collectionName: "groups",
      dialogKey: "groupDialog",
    };
  },
  computed: {
    schema() {
      return Object.assign(
        {
          code: {
            type: "text",
            label: "Code",
            flex: 2,
            sort: 1,
            rules: [
              this.required("Group Code is required"),
              this.minLen(2),
              this.maxLen(8),
            ],
            disabled: true,
          },
          name: {
            type: "text",
            label: "Name",
            flex: 9,
            offset: 1,
            sort: 2,
            rules: [
              this.required("Group Name is required"),
              this.minLen(10),
              this.maxLen(40),
            ],
          },
          pricingPlan: {
            type: "select",
            label: "Pricing Plan",
            items: ["Nucleus", "Atom", "Molecule", "Organic"],
            flex: 5,
            sort: 3,
            rules: [this.required("Pricing Plan is required")],
            disabled: this.isAnyRestaurantOpen(),
          },
          features: {
            type: "text",
            label: "Name",
            flex: 12,
            sort: 4,
            disabled: true,
          },
          adminFullName: {
            type: "text",
            label: "Admin Full Name",
            sort: 5,
            flex: 12,
            disabled: true,
          },
          adminMobile: {
            type: "text",
            label: "Admin Mobile",
            sort: 5,
            flex: 12,
            disabled: true,
          },
          status: {
            type: "select",
            label: "Status",
            items: ["Draft", "Active", "In-Active"],
            flex: 5,
            offset: 2,
            sort: 4,
            rules: [this.required("Status is required")],
            hidden: true,
          },
          productTags: {
            type: "textarea",
            label: "Product Tags",
            flex: 12,
            sort: 5,
            rules: [this.maxLen(200)],
          },
          customTags: {
            type: "textarea",
            label: "Custom Tags",
            flex: 12,
            sort: 6,
            rules: [this.maxLen(200)],
          },
          notes: {
            type: "textarea",
            label: "Notes",
            flex: 12,
            sort: 7,
            rules: [this.maxLen(200)],
          },
        },
        this.baseSchema
      );
    },
  },
  methods: {
    onFormInput(event) {
      this.isDirty = true;
      if (event.key === "pricingPlan") {
        this.selectedGroup.pricingPlan = event.value;
        this.selectedGroup.features = null;
        this.editedItem.features = JSON.stringify(this.myFeatures);
      }
      return event;
    },
    async save() {
      this.selectGroup(await this.saveSync());
      this.isDirty = false;
      this.cancel(this.dialogKey);
    },
    isAnyRestaurantOpen() {
      let answer = false;
      const openRestaurants = this.restaurants.filter((r) => {
        return r.status >= this.STATUSES.OPEN;
      });
      answer = openRestaurants.length != 0;
      return answer;
    },
  },
};
</script>